import { Record } from "immutable";

type SessionUIType = {
  scrolledUp: boolean;
  showEndSessionControlBarButtons: boolean;
  focusedQuestionId?: string;
};

export type OptionalSessionUIType = Partial<SessionUIType>;

const defaultSessionUI: SessionUIType = {
  scrolledUp: false,
  showEndSessionControlBarButtons: false,
  focusedQuestionId: undefined
};

export default class SessionUI extends Record(defaultSessionUI) {}
